/**
 * Created by jonas on 2022-08-12.
 */
import {TheCage} from "../TheCage";
import {TheCageGameAssets} from "../TheCageGameAssets";

export class CounterDisplay extends PIXI.Container {
    public backgroundPlate: PIXI.Sprite;
    private _waysText:PIXI.Sprite;
    protected _text:PIXI.BitmapText;

    constructor(fontStyle:any) {
        super();

        this.backgroundPlate = new PIXI.Sprite(TheCage.assetLoader.getTextures(TheCageGameAssets.COUNTER_BACK_PLATE)[0]);
        this.backgroundPlate.anchor.set(0.5,0.5);

        this._text = new PIXI.BitmapText("", fontStyle);
        this._text.anchor = new PIXI.Point(0.5,0.5);

        this.addChild(this.backgroundPlate);
        this.addChild(this._text);
    }


    public setText(value:string){
        this._text.text = value;
    }

    public animateText(value:number){

    }

}